export const UPDATE_MODEL_EVENT = 'update:modelValue'
export const CHANGE_EVENT = 'change'
export const INPUT_EVENT = 'input'


export function isValidValue(val) {
    return val || val === 0
}

export function isValidArray(val) {
    return Array.isArray(val) && val.length
}

export function toValidArray(val) {
    return Array.isArray(val) ? val : isValidValue(val) ? [val] : []
}

export function treeFind(treeData, findCallback, getChildren, resultCallback, parent) {
    for (let i = 0; i < treeData.length; i++) {
        const data = treeData[i];
        if (findCallback(data, i, treeData, parent)) {
            return resultCallback ? resultCallback(data, i, treeData, parent) : data;
        }
        else {
            const children = getChildren(data);
            if (isValidArray(children)) {
                const find = treeFind(children, findCallback, getChildren, resultCallback, data);
                if (find)
                    return find;
            }
        }
    }
}

export function treeEach(treeData, callback, getChildren, parent) {
    for (let i = 0; i < treeData.length; i++) {
        const data = treeData[i]
        callback(data, i, treeData, parent)
        const children = getChildren(data)
        if (isValidArray(children)) {
            treeEach(children, callback, getChildren, data)
        }
    }
}
